import { Card, CardBody, Col } from 'reactstrap'
import { NestingButton } from '../../../../Utils/Constants'
import { nestingData } from '../../../../Data/Buttons/ButtonGroup'
import StaticNesting from './StaticNesting'
import DynamicNesting from './DynamicNesting'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const Nesting = () => {
  return (
    <>
      <Col lg="6">
        <Card className="height-equal">
          <CardHeaderCommon title={NestingButton} span={nestingData} />
          <CardBody className="btn-group-wrapper">
            <StaticNesting />
            <DynamicNesting />
          </CardBody>
        </Card>
      </Col>
    </>
  )
}

export default Nesting